import React from "react";

interface AppLoaderProps {
  title?: string;
}

const AppLoader: React.FC<AppLoaderProps> = ({ title }) => {
  return (
    <div className="center-align-container">
      <div className="spinner"></div>
      {title && <span>{title}</span>}
    </div>
  );
};

export default AppLoader;
